import type {
  CancelReplanMode,
  CancelReplanStepId,
  CancelReplanWorkflowEvent,
  CancelReplanWorkflowOutputs,
} from "../../../_logic/cancel-replan-contract"
import { type CancelReplanStepOrderOptions, stepOrderForCancelReplanMode } from "./progress"

export const getCancelReplanStepIndex = (
  step: CancelReplanStepId,
  mode: CancelReplanMode,
  options: CancelReplanStepOrderOptions = {},
): number => stepOrderForCancelReplanMode(mode, options).indexOf(step)

export const applyCancelReplanWorkflowEvent = (
  outputs: CancelReplanWorkflowOutputs,
  event: CancelReplanWorkflowEvent,
): CancelReplanWorkflowOutputs => {
  if (event.type === "go_to_step") return outputs

  if (event.type === "cancel.completed") return { cancel: event.output }

  if (event.type === "planning.previewed" || event.type === "planning.committed") {
    return {
      cancel: outputs.cancel,
      cancelAnnouncements: outputs.cancelAnnouncements,
      planning: event.output,
    }
  }

  if (event.type === "cancelAnnouncements.completed") {
    return {
      ...outputs,
      cancelAnnouncements: event.output,
    }
  }

  if (event.type === "summary.finished") {
    return {
      ...outputs,
      summary: event.output,
    }
  }

  return {
    ...outputs,
    announce: event.output,
  }
}

export const nextCancelReplanStep = ({
  currentStep,
  event,
  mode,
}: {
  currentStep: CancelReplanStepId
  event: CancelReplanWorkflowEvent
  mode: CancelReplanMode
}): CancelReplanStepId => {
  if (event.type === "go_to_step") return event.step

  if (event.type === "cancel.completed") return "plan"

  if (event.type === "planning.committed") return "announce"

  if (event.type === "cancelAnnouncements.completed") {
    return mode === "cancelAnnouncementPlans" ? "summary" : "announce"
  }

  if (event.type === "announce.completed") return "summary"

  return currentStep
}
